import React from 'react';
import { MissingRefReportProvider } from '../../missingRefReport/providers/MissingRefReportProvider';
import MissingRefReportQuery from '../../missingRefReport/components/MissingRefReportQuery';

// COMPONENT ---------------------------------------------------------------- //

const MissingRefReportPage: React.FC = () => {
  return (
    <MissingRefReportProvider>
      <MissingRefReportQuery />
    </MissingRefReportProvider>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default MissingRefReportPage;
